<template>
  <div v-if="store.NOTARIA" class="n2-raiz n5-raiz" :data-estilo="estilo" :style="variables">
    <N5Lateral />
    <div class="n5-contenido">
      <v-main id="main" class="n5-main" :class="{ 'n2-main--pagina': !esInicio, 'n2-main--antigua': !esInicio && !propia }">
        <slot>
          <NuxtPage/>
        </slot>
      </v-main>
      <N5Pie />
    </div>
  </div>

  <ClientOnly>
    <div id="client-components-wrapper">
      <ElementsButtonUp />
      <Cookies/>
      <ContactSocialChat v-if="store.NOTARIA?.SocialChat?.Show"/>
      <ChatAIChatbot />
      <SolicitudBotonFlotante />
    </div>
  </ClientOnly>
</template>
<script setup>
// Plantilla 5 de notaría, «panel lateral» (ref: https://trello.com/c/0Ma2vfxV). Comparte estilos y acento con la plantilla 2
import { computed } from 'vue'
import { useStore } from '../store/index.ts'
import { useNotaria2, FUENTES_ESTILO, paginaConDisenoPropio } from '../composables/useNotaria2'
import N5Lateral from '../components/notaria5/N5Lateral.vue'
import N5Pie from '../components/notaria5/N5Pie.vue'
import '../assets/notaria2.scss'
import '../assets/notaria5.scss'

const store = useStore()
// Ruta del router, no useRoute(): en un layout useRoute() espera a que cargue la página
const route = useRouter().currentRoute
const esInicio = computed(() => String(route.value.name || '').replace(/^lang-/, '') === 'index')
// Páginas interiores con el diseño de la plantilla; las demás («antiguas») siguen con los componentes de siempre
const propia = computed(() => paginaConDisenoPropio(route.value.name))
const { estilo, variables } = useNotaria2()

useHead(() => ({
  link: [
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    { rel: 'stylesheet', href: FUENTES_ESTILO[estilo.value] },
  ],
}))
</script>
